export const formatToolsRunQuantity = (
  value: number | string | null | undefined,
) => {
  if (value === null || value === undefined || value === "") return "—";
  const quantity = Number(value);
  if (!Number.isFinite(quantity)) return String(value);
  return quantity.toLocaleString("en-US", { maximumFractionDigits: 3 });
};
